// src/pages/ordens-servico/NovaOSWrapper.jsx
import React from "react";
import { useAuth } from "../../contexts/AuthContext";
import { NIVEIS } from "../../config/niveis";
import NovaOS from "./NovaOS";
import KioskNovaOS from "./KioskNovaOS";

function NovaOSWrapper() {
  const { usuario } = useAuth();

  if (!usuario) {
    return (
      <div style={{ padding: 16 }}>
        <div style={{ opacity: 0.75 }}>Carregando...</div>
      </div>
    );
  }
  const nivel = Number(usuario?.nivel ?? -1);
  const isKiosk = nivel === NIVEIS.KIOSK;

  if (isKiosk) {
    return <KioskNovaOS />;
  }

  return <NovaOS />;
}

export default NovaOSWrapper;
